module.exports = __webpack_public_path__ + "static/media/man (3).56a789a4.png";